import { InventoryType } from "gen/ApiClient";

export const isOfType = (value: string, ...types: InventoryType[]) => types.indexOf(value as any) !== -1;

